import { createRouter, createWebHistory } from 'vue-router'

import api from '@/services/api'
import Login from '@/views/Login.vue'
import StaffSurveys from '@/views/StaffSurveys.vue'
import AvailableSurveys from '@/views/AvailableSurveys.vue'
import SurveyTake from '@/views/SurveyTake.vue'
import DoctorLayout from '@/views/doctor/DoctorLayout.vue'
import DoctorSurveys from '@/views/doctor/DoctorSurveys.vue'
import DoctorHistory from '@/views/doctor/DoctorHistory.vue'
import DoctorSurveyResult from '@/views/doctor/DoctorSurveyResult.vue'

const routes = [
  { path: '/', redirect: '/staff/surveys' },
  { path: '/login', name: 'Login', component: Login },
  {
    path: '/privacy-policy',
    alias: '/privacy',
    name: 'PrivacyPolicy',
    component: () => import('@/views/PrivacyPolicy.vue')
  },
  { path: '/surveys', name: 'AvailableSurveys', component: AvailableSurveys, meta: { redirectDoctor: true } },
  { path: '/surveys/:id', name: 'SurveyTake', component: SurveyTake, meta: { redirectDoctor: true } },
  {
    path: '/doctor',
    component: DoctorLayout,
    meta: { requiresAuth: true, requiresDoctor: true },
    children: [
      { path: '', redirect: '/doctor/passes' },
      { path: 'passes', alias: 'surveys', name: 'DoctorPasses', component: DoctorSurveys },
      {
        path: 'passes/:id',
        alias: 'surveys/:id',
        name: 'DoctorSurveyTake',
        component: SurveyTake,
        meta: { doctorMode: true }
      },
      { path: 'history', name: 'DoctorHistory', component: DoctorHistory },
      { path: 'history/:id', name: 'DoctorSurveyResult', component: DoctorSurveyResult }
    ]
  },
  { path: '/staff', redirect: '/staff/surveys' },
  { path: '/staff/surveys', name: 'StaffSurveys', component: StaffSurveys, meta: { requiresAuth: true, requiresStaff: true } },
  {
    path: '/staff/surveys/create',
    name: 'SurveyBuilder',
    component: () => import('@/views/staff/SurveyBuilder.vue'),
    meta: { requiresAuth: true, requiresStaff: true }
  },
  {
    path: '/staff/surveys/:id/edit',
    name: 'SurveyEdit',
    component: () => import('@/views/staff/SurveyBuilder.vue'),
    meta: { requiresAuth: true, requiresStaff: true }
  },
  {
    path: '/staff/surveys/:id/statistics',
    name: 'SurveyStatistics',
    component: () => import('@/views/staff/SurveyStatistics.vue'),
    meta: { requiresAuth: true, requiresStaff: true }
  },
  {
    path: '/staff/psychological-monitoring',
    name: 'PsychologicalRiskDashboard',
    component: () => import('@/views/staff/PsychologicalRiskDashboard.vue'),
    meta: { requiresAuth: true, requiresStaff: true }
  },
  {
    path: '/staff/users',
    name: 'StaffUsers',
    component: () => import('@/views/staff/Users.vue'),
    meta: { requiresAuth: true, requiresStaff: true }
  },
  {
    path: '/staff/regions',
    name: 'StaffRegions',
    component: () => import('@/views/staff/Directories.vue'),
    props: { directoryType: 'regions' },
    meta: { requiresAuth: true, requiresStaff: true }
  },
  {
    path: '/staff/clinics',
    name: 'StaffClinics',
    component: () => import('@/views/staff/Directories.vue'),
    props: { directoryType: 'clinics' },
    meta: { requiresAuth: true, requiresStaff: true }
  },
  {
    path: '/staff/users/doctors',
    name: 'StaffDoctors',
    component: () => import('@/views/staff/Directories.vue'),
    props: { directoryType: 'doctors' },
    meta: { requiresAuth: true, requiresStaff: true }
  },
  { path: '/staff/directories', redirect: '/staff/regions' },
  {
    path: '/staff/directories/:type(regions|clinics|doctors)',
    redirect: to => to.params.type === 'doctors' ? '/staff/users/doctors' : `/staff/${to.params.type}`
  },
  {
    path: '/staff/mobile-content',
    name: 'MobileContent',
    component: () => import('@/views/staff/MobileContent.vue'),
    meta: { requiresAuth: true, requiresStaff: true }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(async (to, from, next) => {
  if (!to.meta.requiresAuth) {
    if (to.meta.redirectDoctor) {
      try {
        const response = await api.checkAuth()
        if (response.data.user?.type === 'doctor') {
          next('/doctor/passes')
          return
        }
      } catch (_) {
        // Публичные опросы доступны без авторизации.
      }
    }
    next()
    return
  }

  try {
    const response = await api.checkAuth()
    const user = response.data.user
    if (to.meta.requiresStaff && !user.is_staff) {
      next(user.type === 'doctor' ? '/doctor/passes' : '/surveys')
      return
    }
    if (to.meta.requiresDoctor && user.type !== 'doctor') {
      next(user.is_staff ? '/staff/surveys' : '/surveys')
      return
    }
    next()
  } catch (error) {
    next({ path: '/login', query: { next: to.fullPath } })
  }
})

export default router
